import { ReactourStep } from 'reactour';

interface UserRoleTourSteps {
  manageResultSheets: ReactourStep[];
  manageResultSheet: ReactourStep[];
}

export const resultSheetTourSteps: UserRoleTourSteps = {
  manageResultSheet: [
    {
      selector: '',
      content: 'This form will allow you to create or update result sheets.',
    },
    {
      selector: '#result-sheet-configuration',
      content:
        'After you select the subject, the students who follow the subject in the selected batch will be listed below.',
    },
    {
      selector: '.ant-table-row-expand-icon',
      content: 'You can expand and see the sections where you can add marks to.',
    },
    {
      selector: '#result-sheet-save',
      content: 'Saving as a draft will not submit the result sheet.',
    },
    {
      selector: '#result-sheet-submit',
      content: 'Submit will send the result sheet for approval.',
    },
  ],
  manageResultSheets: [
    {
      selector: '',
      content: 'This page will list all the result sheets you can manage.',
    },
    {
      selector: '',
      content: 'You can edit or delete only unapproved result sheets which you have created.',
    },
  ],
};
